module.exports = __webpack_public_path__ + "static/media/infasoft.b6a561dd.png";